import { render, staticRenderFns } from "./CrashHistory.vue?vue&type=template&id=7531ec7e&scoped=true"
import script from "./CrashHistory.vue?vue&type=script&lang=js"
export * from "./CrashHistory.vue?vue&type=script&lang=js"
import style0 from "./CrashHistory.vue?vue&type=style&index=0&id=7531ec7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7531ec7e",
  null
  
)

export default component.exports